/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
import { apiPost } from 'utils'
import { IBannerItem, IBannerRequest, IBannerRowRequest, IOperateRequest } from 'model'
import { IdList, PaginationResponse, XhhyBaseType, XhhyResponse } from 'Xhhy-common/common'

/**
 * 获取banner列表
 * @param params
 */
export const apiBannerList = async (params: IBannerRequest) => {
  return await apiPost<IBannerRequest, PaginationResponse<IBannerItem>>(`/ticpocapi/banner/list`, params)
}

/**
 * 新建banner
 * @param params
 */
export const apiAddBanner = async (params: IBannerRowRequest) => {
  return await apiPost<IBannerRowRequest, XhhyResponse>(`/ticpocapi/banner/save`, params)
}

/**
*  修改Banner
* @param params
*/
export const apiEditBanner = async (params: IBannerRowRequest) => {
  return await apiPost<IBannerRowRequest, XhhyResponse>(`/ticpocapi/banner/update`, params)
}

/**
*  拉取Banner明细
* @param params
*/
export const apiBannerDetail = async (params: XhhyBaseType) => {
  return await apiPost<XhhyBaseType, IBannerRowRequest>(`/ticpocapi/banner/selectEditDetailInfo`, params)
}

/**
* 删除Banner
* @param params
*/
export const apiDeleteBanner = async (params: IdList) => {
  return await apiPost<IdList, XhhyResponse>(`/ticpocapi/banner/delete`, params)
}

/**
* 设为无效有效
* @param params
*/
export const apiOoperateBanner = async (params: Array<IOperateRequest>) => {
  return await apiPost<Array<IOperateRequest>, XhhyResponse>(`/ticpocapi/banner/operate`, params)
}

